// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  websiteUrl: 'https://mavendevelopments.us/',
  // apiUrl: 'https://socialnuts-eg.com/porjects/maven2021_backend/api/',
  // imgUrl: 'https://socialnuts-eg.com/porjects/maven2021_backend/public/images/',
  // apiUrl: 'https://social-nuts.tech/maven2021/maven2021_backend/api/',
  // imgUrl: 'https://social-nuts.tech/maven2021/maven2021_backend/public/images/',
  apiUrl: 'https://api.mavendevelopments.us/api/',
  imgUrl: 'https://api.mavendevelopments.us/images/',
  production: false
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
